import React, { FC, useCallback } from "react";
import { IconButton } from "@evergis/ui";
import { ResourceTypeLink } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { useBulkCopyResourceDialog } from "../../../../hooks/useDialogs";
import { useBulkCopyTablesJob } from "../../../../components/Dialogs/BulkCopy/hooks/useBulkCopyTablesJob";
import { useLimitsExceededCheck } from "../../../../hooks/useLimitsExceededCheck";
import { useResourceType } from "../../../../hooks/useResourceType";

export const CopyResources: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { t } = useTranslation("common");
  const openBulkCopyResourceDialog = useBulkCopyResourceDialog();
  const { onCopy: bulkCopyTables } = useBulkCopyTablesJob();
  const [resourceType] = useResourceType();
  const copyAction = resourceType !== ResourceTypeLink.Table ? () => openBulkCopyResourceDialog() : bulkCopyTables;
  const openCopyResourceDialog = useLimitsExceededCheck(copyAction);

  const openDialog = useCallback(
    () => openCopyResourceDialog(["copyResources", resourceType]),
    [openCopyResourceDialog, resourceType],
  );

  return <IconButton kind={"copy"} title={t("actions.copy")} disabled={disabled} onClick={openDialog} />;
};
